<template>
  <div>
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>分组管理</el-breadcrumb-item>
          <el-breadcrumb-item>所有分组</el-breadcrumb-item>
          <el-breadcrumb-item>{{fPGrpName}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{fGrpName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="demo-form-inline">
        <el-form-item label="用户编号::">
          <el-input placeholder="请输入用户编号"
                    v-model="fUsrNoQuery"
                    class="input-with-select"></el-input>
        </el-form-item>
        <el-form-item label="用户姓名::">
          <el-input placeholder="请输入用户姓名"
                    v-model="fUsrNameQuery"
                    class="input-with-select"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="usrQuery">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right">
          <el-button type="primary"
                     size="small"
                     @click="addUser"
                     v-if="is_edit">新增用户</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-tabs v-model="activeName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="用户信息"
                     name="userInfo">
          <el-row>
            <el-table :data="userList"
                      border
                      style="width: 100%"
                      :height="tableHeight">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fGrpName"
                               label="分组名称">
              </el-table-column>
              <el-table-column prop="fUsrNo"
                               label="用户编号">
              </el-table-column>
              <el-table-column prop="fUsrName"
                               label="用户姓名">
              </el-table-column>
              <el-table-column prop="fUsrMobile"
                               label="联系电话">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column fixed="right"
                               width="350"
                               align="center"
                               label="操作">
                <template slot-scope="scope">
                  <el-button @click="viewUser(scope.$index, scope.row)"
                             type="success"
                             style="background-color:#5bc0de;border-color:#5bc0de"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="updateUser(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="resetPwd(scope.$index, scope.row)"
                             v-if="is_reset">重置密码</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="delUser(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row class="pagination">
            <el-col :span="24">
              <div class="block">
                <span class="demonstration"></span>
                <el-pagination background
                               @size-change="handleSizeChange"
                               :current-page.sync="pageNo"
                               @current-change="handlePage"
                               :page-sizes="[10, 20, 50, 100]"
                               layout="total,sizes, prev, pager, next, jumper"
                               :total="total"
                               v-if="total>0">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="分组信息"
                     name="groupInfo">
          <el-row>
            <el-table :data="grpInfoList"
                      border
                      style="width: 100%"
                      :height="tableHeight"
                      :header-cell-style="{padding:'0px',height:'35px'}"
                      :cell-style="{padding:'0px',height:'35px'}">
              <el-table-column prop="fGrpName"
                               label="分组名称">
              </el-table-column>
              <el-table-column prop="fIsAdmin"
                               label="组类型">
              </el-table-column>
              <el-table-column prop="fModName"
                               label="模块名称">
              </el-table-column>
              <el-table-column prop="fPersName"
                               label="权限名称">
              </el-table-column>
              <el-table-column prop="fFunName"
                               label="功能按钮描述">
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="客户信息"
                     name="parkInfo">
          <el-row>
            <el-table :data="grpParkList"
                      border
                      style="width: 100%"
                      :height="tableHeight"
                      :header-cell-style="{padding:'0px',height:'35px'}"
                      :cell-style="{padding:'0px',height:'35px'}">
              <el-table-column type="index"
                               label="序号"
                               width="50">
              </el-table-column>
              <el-table-column prop="unionName"
                               label="绑定客户">
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row>
      <div class="userMainEdit">
        <el-dialog :title="titleMap[form.operateFlag]"
                   :visible.sync="dialogFormVisible"
                   v-dialogDrag
                   top="7vh"
                   left="0vh"
                   width="35%"
                   @close="resetForm('form')"
                   @open="openFun">
          <el-form :model="form"
                   :rules="rules"
                   label-width="90px"
                   ref="form"
                   class="userForm">
            <el-form-item label="用户编号::"
                          prop="fUsrNo">
              <el-input v-model="form.fUsrNo"
                        autocomplete="off"
                        :disabled="!isEdit || form.fUsrNo==='rjadmin0001'"></el-input>
            </el-form-item>
            <el-form-item label="密码::"
                          prop="fUsrPwd"
                          v-if="form.operateFlag == 'add'">
              <el-input :type="passw"
                        v-model="form.fUsrPwd"
                        autocomplete="off"
                        :disabled="form.isUsrEdit || !isEdit">
                <i slot="suffix"
                   :class="icon"
                   @click="showPass"></i>
              </el-input>
            </el-form-item>
            <div style="color:red;padding-left:90px;"
                 v-if="form.operateFlag == 'add'">初始密码:{{pwd}}</div>
            <el-form-item label="确认密码::"
                          prop="checkPass"
                          v-if="form.operateFlag == 'add'">
              <el-input :type="passW"
                        v-model="form.checkPass"
                        autocomplete="off"
                        :disabled="form.isUsrEdit || !isEdit">
                <i slot="suffix"
                   :class="icons"
                   @click="showPassw"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="用户姓名::"
                          prop="fUsrName">
              <el-input v-model="form.fUsrName"
                        autocomplete="off"
                        :disabled="!isEdit"></el-input>
            </el-form-item>
            <el-form-item label="联系电话::">
              <el-input v-model="form.fUsrMobile"
                        autocomplete="off"
                        :disabled="!isEdit"></el-input>
            </el-form-item>
            <el-form-item label="备注信息::"
                          prop="desc">
              <el-input type="textarea"
                        v-model="form.fRemark"
                        :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer"
               class="dialog-footer"
               style="padding-top: 10px">
            <el-button type="primary"
                       @click="submitForm('form')"
                       v-if="isEdit">保存</el-button>
            <el-button @click="dialogFormVisible = false">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </el-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as api from '@/api/user'
export default {
  name: 'userMain.vue',
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.fUsrPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (this.isLoginValidate) {
        if (!((value || '').length >= 8 && (value || '').length <= 30)) {
          callback(new Error('长度为8到30个字符'))
        }
        if (!/^([a-zA-Z]+[0-9]+[!@#$%^&*]+)|([a-zA-Z]+[!@#$%^&*]+[0-9]+)|([0-9]+[!@#$%^&*]+[a-zA-Z]+)|([0-9]+[a-zA-Z]+[!@#$%^&*]+)|([!@#$%^&*]+[a-zA-Z]+[0-9]+)|([!@#$%^&*]+[0-9]+[a-zA-Z]+)$/.test(value)) {
          callback(new Error('密码必须要包含字母、数字和特殊符号'))
        }
      } else {
        if (!((value || '').length >= 6 && (value || '').length <= 30)) {
          callback(new Error('长度为6到30个字符'))
        }
      }
      callback()
    }
    return {
      passw: 'password',
      passW: 'password',
      icon: 'el-input__icon el-icon-view',
      icons: 'el-input__icon el-icon-view',
      isEdit: false,
      is_edit: false,
      is_del: false,
      is_bind: false,
      is_reset: false,
      isLoginValidate: false,
      fUsrNoQuery: '',
      fUsrNameQuery: '',
      fGrpName: '',
      fPGrpName: '',
      pwd: '',
      form: {
        fGrpID: '',
        fLevel: '',
        operateFlag: '',
        fUsrID: '',
        fUsrNo: '',
        fUsrPwd: '666666',
        checkPass: '666666',
        fUsrName: '',
        fUsrMobile: '',
        fRemark: '',
        isUsrEdit: false
      },
      tableHeight: 0,
      activeName: 'userInfo',
      grpInfoList: [],
      grpParkList: [],
      rules: {
        fUsrNo: [
          { required: true, message: '请输入用户编号', trigger: 'blur' },
          { min: 6, max: 16, message: '长度为6到16个字符', trigger: 'blur' }
        ],
        fUsrPwd: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { validator: validatePwd, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请再次输入用户密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ],
        fUsrName: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ]
      },
      userList: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      titleMap: {
        add: '新增用户',
        edit: '编辑用户',
        view: '查看用户'
      },
      pageSize: 10,
      pageNo: 1,
      total: 0
    }
  },
  methods: {
    ...mapActions([
      'editUser', 'getUserByGroupId', 'deleteUser', 'getPerAndParkByParent', 'resetUserPwd', 'getCurrentUserPers'
    ]),
    usrQuery () {
      this.initData()
    },
    showPass () {
      let passw = this.passw
      if (passw === 'text') {
        this.passw = 'password'
        this.icon = 'el-input__icon el-icon-view'
      } else {
        this.passw = 'text'
        this.icon = 'el-input__icon el-icon-loading'
      }
    },
    showPassw () {
      let passW = this.passW
      if (passW === 'text') {
        this.passW = 'password'
        this.icons = 'el-input__icon el-icon-view'
      } else {
        this.passW = 'text'
        this.icons = 'el-input__icon el-icon-loading'
      }
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    openFun (formName, type) {
      this.$nextTick(() => {
        if (this.$refs[formName]) {
          this.$refs[formName].resetFields()
        }
        this.setDefaultValue()
        this.dialogFormVisible = true
      })
    },
    tabClick (tab, event) {
      let param = {}
      param.fGrpID = this.form.fGrpID
      this.getPerAndParkByParent(param).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let list = []
              Object.assign(list, data.Data.pers)
              this.grpInfoList = list
              let custs = []
              Object.assign(custs, data.Data.bindCusts)
              this.grpParkList = custs
            }
          }
        }
      })
    },
    initData () {
      this.form.fGrpID = this.$route.query.fGrpID
      this.form.fLevel = this.$route.query.fLevel
      let param = {}
      param.fGrpID = this.form.fGrpID
      param.pageSize = this.pageSize
      param.pageNo = this.pageNo
      param.fUsrNo = this.fUsrNoQuery
      param.fUsrName = this.fUsrNameQuery
      this.getUserByGroupId(param).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let list = []
              Object.assign(list, data.Data.rows)
              this.userList = list
              this.total = data.Data.total
            }
          }
        }
      })
      this.tabClick()
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    setDefaultValue () {
      this.form.fUsrID = ''
      this.form.fUsrNo = ''
      this.form.fUsrPwd = this.pwd
      this.form.checkPass = this.pwd
      this.form.fUsrName = ''
      this.form.fUsrMobile = ''
      this.form.fRemark = ''
    },
    addUser () {
      this.isEdit = true
      this.form.isUsrEdit = false
      this.form.operateFlag = 'add'
      // this.openFun('form', 'add')
      this.setDefaultValue()
      this.dialogFormVisible = true
    },
    viewUser (index, info) {
      this.isEdit = false
      this.form.isUsrEdit = true
      this.form.operateFlag = 'view'
      this.openFun('form', 'view')
      api.getUserInfo(info.fUsrID).then(res => {
        if (res && res.data) {
          let { data } = res
          if (data.IsOk) {
            Object.assign(this.form, data.Data)
          }
        }
      })
    },
    updateUser (index, info) {
      this.isEdit = true
      this.form.isUsrEdit = true
      this.form.operateFlag = 'edit'
      this.openFun('form', 'edit')
      api.getUserInfo(info.fUsrID).then(res => {
        if (res && res.data) {
          let { data } = res
          if (data.IsOk) {
            Object.assign(this.form, data.Data)
          }
        }
      })
    },
    resetPwd (index, info) {
      this.$confirm('确认重置该用户[' + info.fUsrName + ']密码为初始密码:' + this.pwd + ', 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.resetUserPwd(info.fUsrID).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: '重置成功!'
                })
              }
            }
          }
        })
      }).catch(() => { })
    },
    delUser (index, info) {
      let fUsrNo = info.fUsrNo
      if (fUsrNo === 'rjadmin0001') {
        this.$alert('管理员不能删除', '删除用户', {
          confirmButtonText: '确定'
        })
        return
      }
      let param = {}
      param['fUsrID'] = info.fUsrID
      this.$confirm('此操作将永久删除该用户[' + info.fUsrName + '], 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.deleteUser(param).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.pageNo = 1
                this.initData()
              }
            }
          }
        })
      }).catch(() => { })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editUser(this.form).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status !== 200) {
                this.$message({
                  type: 'success',
                  message: '用户操作出错'
                })
              } else {
                if (!data.IsOk) {
                  this.$message.error(data.Msg)
                } else {
                  this.initData()
                  this.dialogFormVisible = false
                }
              }
            }
          })
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.passw = 'password'
      this.icon = 'el-input__icon el-icon-view'
      this.passW = 'password'
      this.icons = 'el-input__icon el-icon-view'
    }
  },
  watch: {
    '$route': 'initData'
  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  created () {
    api.initConfig().then((res) => {
      let { data } = res
      if (data.IsOk) {
        this.isLoginValidate = data.Data.validate
        this.pwd = data.Data.pwd
      }
    })
    this.getCurrentUserPers({ perTypeId: 10000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_bind = data.Data.data.is_bind
            this.is_reset = data.Data.data.is_reset
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    this.fPGrpName = this.$route.query.fPGrpName
    this.fGrpName = this.$route.query.fGrpName
    this.initData()
    let sizethis = this
    window.onresize = () => {
      let clientHeight = sizethis.getRJPageSize.getRJPageSize()[3] - 270
      sizethis.tableHeight = clientHeight
    }
  },
  updated () {
    let clientHeight = this.getRJPageSize.getRJPageSize()[3] - 270
    this.tableHeight = clientHeight
  }
}
</script>
<style>
.userMainEdit .el-dialog__title {
  color: white;
}
.userMainEdit .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.userMainEdit .el-dialog__body {
  padding-top: 20px;
  padding-left: 20px;
  padding-left: 20px;
  padding-bottom: 0px;
}
.userMainEdit .el-input.is-disabled .el-input__inner,
.userMainEdit .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
</style>
<style scoped>
.userForm {
  max-width: 500px;
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/view/user/userMain.vue